/**
 * announcement
 */

const announcement = {
    cfg:  {
        name: 'announcement',
        infoBox: document.querySelector('.js-announcement'),
        closeBtn: document.querySelector('#js-infoboxClose'),
        openBtn: document.querySelector('#js-infoboxOpen'),
        contentLinks: document.querySelectorAll('.js-infoboxContent a'),
    },

    closeBox() {
        sessionStorage.setItem('infobox', 'is-closed');
        this.cfg.infoBox.classList.add('is-closed');
    },

    openBox() {
        sessionStorage.setItem('infobox', 'is-open');
        this.cfg.infoBox.classList.remove('is-closed');
    },

    getVar() {

    },

    init() {
        if (this.cfg.infoBox) {
            this.cfg.closeBtn.addEventListener('click', () => {
                this.closeBox();
            });
            this.cfg.openBtn.addEventListener('click', () => {
                this.openBox();
            });

            const cookie = sessionStorage.getItem('infobox');

            if (cookie !== null) {
                this.cfg.infoBox.classList.add(cookie);
            }

            const now = new Date();
            const from = new Date(this.cfg.infoBox.dataset.from);
            const to = new Date(this.cfg.infoBox.dataset.to);

            if (now >= to || now <= from) {
                this.cfg.infoBox.classList.add('hidden');
            }

            this.cfg.contentLinks.forEach((t) => {
                t.addEventListener('click', (e) => {
                    this.closeBox();
                });
            });

            document.addEventListener('click', (e) => {
                let targetElement = e.target;

                do {
                    if (targetElement === this.cfg.navWrapper || targetElement === this.cfg.navBarToggle) {
                        return;
                    }
                    // Go up the DOM
                    targetElement = targetElement.parentNode;
                } while (targetElement);

                if (!this.cfg.infoBox.classList.contains('hidden')) {
                    // this.closeBox();
                }
            });
        }
    }
};

export default announcement;



// WEBPACK FOOTER //
// ./___src/templates/_atoms/announcement/_script.js